"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var social_groups_api_1 = require("@wix/social-groups-api");
var PubSubEventTypes_1 = require("../pubSub/PubSubEventTypes");
var lodash_1 = require("lodash");
var loggers_1 = require("@wix/social-groups-common/dist/src/loggers");
var Controller_1 = require("../Controller");
var utils_1 = require("../../seo/utils");
var types_1 = require("../../seo/types");
var routeParams_1 = require("../routeParams");
exports.MEMBERS_APP_DEF_ID = '14cc59bc-f0b7-15b8-e1c7-89ce41d0e0c9';
var MembersController = /** @class */ (function (_super) {
    tslib_1.__extends(MembersController, _super);
    function MembersController(controllerConfig, group) {
        var _this = _super.call(this, controllerConfig, group.groupId) || this;
        _this.group = group;
        _this.membersToAdd = new Set();
        _this.currentMember = social_groups_api_1.Anonymous;
        _this.setMembers = function (group) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a, members, siteMembers, siteMembersMap, currentMember, currentSiteMember, e_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getMembers(group)];
                    case 1:
                        _a = _b.sent(), members = _a.members, siteMembers = _a.siteMembers, siteMembersMap = _a.siteMembersMap, currentMember = _a.currentMember, currentSiteMember = _a.currentSiteMember;
                        this.setProps({
                            members: members,
                            siteMembers: siteMembers,
                            siteMembersMap: siteMembersMap,
                            currentMember: currentMember,
                            currentSiteMember: currentSiteMember,
                            isLoggedIn: this.isUserLoggedIn(),
                            membersUpdate: tslib_1.__spread(this.membersToAdd),
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _b.sent();
                        loggers_1.ConsoleLogger.log(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.filterMembers = function (group, searchQuery) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var filteredMembersResponse, filteredMembers, query, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filteredMembers = [];
                        query = {
                            groupId: group.groupId,
                            query: {
                                filter: {
                                    nickname: {
                                        $contains: searchQuery,
                                    },
                                },
                            },
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        if (!social_groups_api_1.canFetchAllMembers(group)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.api.queryAllMembers(query)];
                    case 2:
                        filteredMembersResponse = _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.api.queryGroupMembers(query)];
                    case 4:
                        filteredMembersResponse = _a.sent();
                        _a.label = 5;
                    case 5:
                        filteredMembers = filteredMembersResponse.data.members || [];
                        return [3 /*break*/, 8];
                    case 6:
                        e_2 = _a.sent();
                        loggers_1.ConsoleLogger.log(e_2);
                        return [3 /*break*/, 8];
                    case 7:
                        this.setProps({
                            membersQueryResponse: {
                                query: searchQuery,
                                members: filteredMembers.slice(0, Math.min(filteredMembers.length, 5)),
                            },
                        });
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        _this.addMember = function (group, memberId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var e_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.membersToAdd.add(memberId);
                        this.controllerConfig.setProps({
                            membersUpdate: tslib_1.__spread(this.membersToAdd),
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        return [4 /*yield*/, this.api.addToGroup(group.groupId, [memberId])];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.setMembers(group)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        e_3 = _a.sent();
                        loggers_1.ConsoleLogger.log(e_3);
                        return [3 /*break*/, 6];
                    case 5:
                        this.membersToAdd.delete(memberId);
                        if (!this.membersToAdd.size) {
                            this.controllerConfig.setProps({
                                membersUpdate: tslib_1.__spread(this.membersToAdd),
                            });
                            this.publishGroupUpdate(group.groupId);
                        }
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        _this.openCurrentUserProfile = function () {
            _this.getLocation().to('/account/profile');
        };
        _this.openUserProfile = function (siteMemberId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var membersApi, e_4;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.controllerConfig.wixCodeApi.site.getPublicAPI(exports.MEMBERS_APP_DEF_ID)];
                    case 1:
                        membersApi = _a.sent();
                        membersApi.navigateToMember({ memberId: siteMemberId });
                        return [3 /*break*/, 3];
                    case 2:
                        e_4 = _a.sent();
                        console.error('Navigate to profile: FAIL');
                        this.getLocation().to("/profile/" + siteMemberId);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.removeMembersFromGroup = function (groupId, siteMemberIds) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var e_5;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        return [4 /*yield*/, this.api.removeFromGroup(groupId, siteMemberIds)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.setMembers(this.group)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        e_5 = _a.sent();
                        loggers_1.ConsoleLogger.log(e_5);
                        return [3 /*break*/, 5];
                    case 4:
                        this.publishGroupUpdate(groupId);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.changeMemberRoleInGroup = function (groupId, siteMemberId, role) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var e_6;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        return [4 /*yield*/, this.api.setMemberRole(groupId, siteMemberId, role)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.setMembers(this.group)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        e_6 = _a.sent();
                        loggers_1.ConsoleLogger.log(e_6);
                        return [3 /*break*/, 5];
                    case 4:
                        this.publishGroupUpdate(groupId);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.getNewMembers = function (groupId, startDate) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var newMembers, data, e_7;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.countNewMembers(groupId, {
                                filter: {
                                    dateUpdated: { $gte: startDate.toISOString() },
                                },
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        newMembers = data.newMembers;
                        return [3 /*break*/, 3];
                    case 2:
                        e_7 = _a.sent();
                        console.error(e_7);
                        newMembers = 0;
                        return [3 /*break*/, 3];
                    case 3:
                        this.setProps({ newMembers: newMembers });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.makeProfilePublic = function (siteMemberId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var member, e_8;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.updateSiteMemberPrivacy(siteMemberId, social_groups_api_1.SiteMemberPrivacyStatus.PUBLIC)];
                    case 1:
                        member = (_a.sent()).data.member;
                        this.setProps({ currentSiteMember: member });
                        return [3 /*break*/, 3];
                    case 2:
                        e_8 = _a.sent();
                        console.error('Update site member profile: FAIL', e_8);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.getPendingMembers = function (groupId, limit, cursor) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var data, e_9;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.listPendingMembers(groupId, limit, cursor)];
                    case 1:
                        data = (_a.sent()).data;
                        //TODO: cursor tokens
                        this.setProps({
                            pendingMembers: data,
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        e_9 = _a.sent();
                        console.error('List Pending Members: FAIL');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.approvePendingMembersRequests = function (groupId, siteMemberIds) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var e_10;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.api.approveGroupMembershipRequests(groupId, siteMemberIds)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, Promise.all([
                                this.getPendingMembers(groupId),
                                this.publishGroupUpdate(groupId),
                            ])];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        e_10 = _a.sent();
                        console.error('Approve Pending Members: FAIL');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.followMember = function (siteMemberId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var e_11;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.followMember(siteMemberId)];
                    case 1:
                        _a.sent();
                        this.followingMembers.push(siteMemberId);
                        this.setProps({ followingMembers: this.followingMembers });
                        return [3 /*break*/, 3];
                    case 2:
                        e_11 = _a.sent();
                        console.error('Follow members: FAIL', e_11);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.unfollowMember = function (siteMemberId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var e_12;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.unfollowMember(siteMemberId)];
                    case 1:
                        _a.sent();
                        this.followingMembers.splice(this.followingMembers.indexOf(siteMemberId), 1);
                        this.setProps({ followingMembers: this.followingMembers });
                        return [3 /*break*/, 3];
                    case 2:
                        e_12 = _a.sent();
                        console.error('Unfollow members: FAIL', e_12);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.getFollowingMembers = function (userId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var userIds, e_13;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.getFollowingMembers(userId)];
                    case 1:
                        userIds = (_a.sent()).data.userIds;
                        this.followingMembers = userIds;
                        this.setProps({ followingMembers: this.followingMembers });
                        return [3 /*break*/, 3];
                    case 2:
                        e_13 = _a.sent();
                        console.error('Get following members: FAIL', e_13);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.rejectPendingMembersRequests = function (groupId, siteMemberIds) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var e_14;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.api.rejectGroupMembershipRequests(groupId, siteMemberIds)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, Promise.all([
                                this.getPendingMembers(groupId),
                                this.publishGroupUpdate(groupId),
                            ])];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        e_14 = _a.sent();
                        console.error('Reject Pending Members: FAIL');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.setApi(_this.getSiteToken());
        _this.setSubscriptions();
        _this.onUserLogin(function (_a) {
            var instance = _a.instance;
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var e_15;
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            this.setApi(instance);
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 4, , 5]);
                            return [4 /*yield*/, this.setCurrentMember()];
                        case 2:
                            _b.sent();
                            return [4 /*yield*/, this.setMembers(group)];
                        case 3:
                            _b.sent();
                            return [3 /*break*/, 5];
                        case 4:
                            e_15 = _b.sent();
                            loggers_1.ConsoleLogger.log(e_15);
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        });
        return _this;
    }
    MembersController.prototype.getMembers = function (group) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var siteMembers, members, siteMembersMap, id, currentSiteMember;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.isUserLoggedIn() && social_groups_api_1.canFetchAllMembers(group))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetchAllMembers(group.groupId)];
                    case 1:
                        siteMembers = _a.sent();
                        members = siteMembers.filter(social_groups_api_1.isJoined);
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.fetchGroupMembers(group.groupId)];
                    case 3:
                        siteMembers = _a.sent();
                        members = siteMembers;
                        _a.label = 4;
                    case 4:
                        siteMembersMap = lodash_1.keyBy(siteMembers, 'siteMemberId');
                        id = this.getCurrentUser().id;
                        this.currentMember = siteMembersMap[id] || social_groups_api_1.Anonymous;
                        return [4 /*yield*/, this.getCurrentSiteMember()];
                    case 5:
                        currentSiteMember = _a.sent();
                        return [2 /*return*/, {
                                members: members,
                                siteMembers: siteMembers,
                                siteMembersMap: siteMembersMap,
                                currentMember: this.currentMember,
                                currentSiteMember: currentSiteMember,
                            }];
                }
            });
        });
    };
    MembersController.prototype.getCurrentSiteMember = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var member, e_16;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isUserLoggedIn()) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api.getCurrentSiteMember()];
                    case 2:
                        member = (_a.sent()).data.member;
                        return [2 /*return*/, member];
                    case 3:
                        e_16 = _a.sent();
                        console.error('Get current site member profile: FAIL', e_16);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MembersController.prototype.fetchAllMembers = function (groupId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var limit, data, e_17;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        limit = 1000;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api.listAllMembers(groupId, {
                                limit: limit,
                            })];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.members];
                    case 3:
                        e_17 = _a.sent();
                        loggers_1.ConsoleLogger.log(e_17);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, []];
                }
            });
        });
    };
    MembersController.prototype.fetchGroupMembers = function (groupId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var limit, data, e_18;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        limit = 1000;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api.listGroupMembers(groupId, {
                                limit: limit,
                                includeDeleted: true,
                            })];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.members];
                    case 3:
                        e_18 = _a.sent();
                        loggers_1.ConsoleLogger.log(e_18);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, []];
                }
            });
        });
    };
    MembersController.prototype.publishGroupUpdate = function (groupId) {
        try {
            this.controllerConfig.platformAPIs.pubSub.publish(PubSubEventTypes_1.PubSubEventTypes.UPDATE_GROUP_EVENT, groupId, false);
        }
        catch (e) {
            loggers_1.ConsoleLogger.log(e);
        }
    };
    MembersController.prototype.setApi = function (siteToken) {
        this.api = new social_groups_api_1.MembersApi(siteToken, this.getApiBaseUrl());
    };
    MembersController.prototype.setSubscriptions = function () {
        var _this = this;
        try {
            this.controllerConfig.platformAPIs.pubSub.subscribe(PubSubEventTypes_1.PubSubEventTypes.UPDATE_MEMBERS_EVENT, function () {
                try {
                    return _this.setMembers(_this.group);
                }
                catch (e) { }
            }, false);
        }
        catch (e) {
            loggers_1.ConsoleLogger.log(e);
        }
    };
    MembersController.prototype.setProps = function (props) {
        this.controllerConfig.setProps(props);
    };
    MembersController.prototype.pageReady = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.setProps({
                    membersActions: {
                        addMember: this.addMember,
                        approvePendingMembersRequests: this.approvePendingMembersRequests,
                        changeMemberRoleInGroup: this.changeMemberRoleInGroup,
                        filterMembers: this.filterMembers,
                        getNewMembers: this.getNewMembers,
                        getPendingMembers: this.getPendingMembers,
                        makeProfilePublic: this.makeProfilePublic,
                        openCurrentUserProfile: this.openCurrentUserProfile,
                        followMember: this.followMember,
                        unfollowMember: this.unfollowMember,
                        getFollowingMembers: this.getFollowingMembers,
                        openUserProfile: this.openUserProfile,
                        rejectPendingMembersRequests: this.rejectPendingMembersRequests,
                        removeMembersFromGroup: this.removeMembersFromGroup,
                        setMembers: this.setMembers,
                    },
                });
                try {
                    return [2 /*return*/, this.setMembers(this.group)];
                }
                catch (e) {
                    loggers_1.ConsoleLogger.log(e);
                }
                return [2 /*return*/];
            });
        });
    };
    MembersController.prototype.getInitialProps = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var itemType, siteMembersMap, siteMembers, currentMember, isSEO, isMembersTab, getMembersResponse, initialProps;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        itemType = utils_1.getGroupSEOItemType(routeParams_1.groupRoute(this.controllerConfig.wixCodeApi.location));
                        siteMembersMap = {};
                        siteMembers = [];
                        currentMember = social_groups_api_1.Anonymous;
                        isSEO = [
                            types_1.GroupSEOItemType.GROUPS_POST,
                            types_1.GroupSEOItemType.GROUPS_MEMBERS,
                            types_1.GroupSEOItemType.GROUPS_COMMENT,
                        ].includes(itemType);
                        isMembersTab = this.getLocation();
                        if (!isSEO) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getMembers(this.group)];
                    case 1:
                        getMembersResponse = _a.sent();
                        siteMembersMap = getMembersResponse.siteMembersMap;
                        siteMembers = getMembersResponse.siteMembers;
                        currentMember = getMembersResponse.currentMember;
                        _a.label = 2;
                    case 2:
                        initialProps = {
                            currentMember: currentMember,
                            followingMembers: [],
                            membersQueryResponse: social_groups_api_1.MembersQueryInitialResponse,
                            siteMembers: siteMembers,
                            siteMembersMap: siteMembersMap,
                        };
                        return [2 /*return*/, Promise.resolve(initialProps)];
                }
            });
        });
    };
    MembersController.prototype.getCurrentMember = function (memberId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, e_19;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.getGroupMember(this.group.groupId, memberId)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.member || social_groups_api_1.Anonymous];
                    case 2:
                        e_19 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, social_groups_api_1.Anonymous];
                }
            });
        });
    };
    MembersController.prototype.setCurrentMember = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var id, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        id = this.getCurrentUser().id;
                        _a = this;
                        return [4 /*yield*/, this.getCurrentMember(id)];
                    case 1:
                        _a.currentMember = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return MembersController;
}(Controller_1.Controller));
exports.MembersController = MembersController;
//# sourceMappingURL=MembersController.js.map